module.exports = __webpack_public_path__ + "img/zimi.ca7b7b6f.jpg";